/**
 * Single source of truth for subscription-by-id lookups in mock API
 * This utility creates a lookup from the list fixtures to ensure consistency
 */

import FixtureAPIGetUserSubscriptions from "./fixtures/get-user-subscriptions";

// Build a lookup map of all subscriptions by ID from the list
const buildSubscriptionLookup = () => {
  const lookup: Record<string, any> = {};

  FixtureAPIGetUserSubscriptions.payload.subscriptions.forEach((sub: any) => {
    lookup[sub.id.id] = { payload: { subscription: sub } };
  });

  return lookup;
};

// Export the lookup map
export const SubscriptionLookup = buildSubscriptionLookup();

// Export a helper function to get a subscription by ID
export const getSubscriptionFixtureById = (id: string) => {
  return SubscriptionLookup[id] || null;
};

// Export available subscription IDs for debugging
export const AVAILABLE_IDS = Object.keys(SubscriptionLookup);





